// Author : Vishnu
// Version :0.0.1
// MODIFIED DATE: 21/08/2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	getBalanceSheetReportFailure,
	getBalanceSheetReportResponseChanged,
	getBalanceSheetReportSuccess,
	getProfitLossReportFailure,
	getProfitLossReportResponseChanged,
	getProfitLossReportSuccess,
} from './balance-sheet.action';
import BalanceSheetType from './balance-sheet.types';
import { balancesheetReportList, profitLossReportList } from './balance-sheet.service';

/** *********************  START GET PROFIT LOSS REPORT TRANSACTION LIST  ******************** */
export function* profitLossReportDetailsListGet({ payload }: any) {
	try {
		const key = 'GetProfitLossReportKey';
		const { databaseName, branchID, companyID, infogCompanyID, asOnDate, filterHOTrxn } =
			payload;
		const jsonData = {
			DatabaseName: databaseName,
			UserAccessBranchID: branchID,
			CompanyID: companyID,
			Infog_CompanyID: infogCompanyID,
			AccountHeadID: infogCompanyID,
			FilterHOTrxn: filterHOTrxn,
			AsOnDate: asOnDate,
			FromDate: asOnDate,
			ToDate: asOnDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(profitLossReportList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getProfitLossReportFailure(responseData.data));
		} else {
			yield put(getProfitLossReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getProfitLossReportFailure(error));
	}
}
export function* resetGetProfitLossReportListResponse() {
	yield put(getProfitLossReportResponseChanged());
}

export function* onGetProfitLossReportListDetails() {
	yield takeLatest(BalanceSheetType.GET_PROFIT_LOSS_REPORT_START, profitLossReportDetailsListGet);
}

export function* onGetprofitLossReportListResponseReset() {
	yield takeLatest(
		BalanceSheetType.GET_PROFIT_LOSS_REPORT_RESPONSE_RESET,
		resetGetProfitLossReportListResponse,
	);
}
/** *********************  END GET PROFIT LOSS REPORT TRANSACTION LIST ******************** */

/** *********************  START GET BALANCE SHEET REPORT LIST  ******************** */
export function* balancesheetReportListGet({ payload }: any) {
	try {
		const key = 'GetBalanceSheetReportKey';
		const { databaseName, asOnDate, infogCompanyID, companyID, branchID, filterHOTrxn } =
			payload;
		const jsonData = {
			DatabaseName: databaseName,
			AsOnDate: asOnDate,
			FromDate: asOnDate,
			ToDate: asOnDate,
			Infog_CompanyID: infogCompanyID,
			CompanyID: companyID,
			UserAccessBranchID: branchID,
			Type: 'type',
			FilterHOTrxn: filterHOTrxn,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(balancesheetReportList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBalanceSheetReportFailure(responseData.data));
		} else {
			yield put(getBalanceSheetReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBalanceSheetReportFailure(error));
	}
}

export function* resetGetBalanceSheetReportResponse() {
	yield put(getBalanceSheetReportResponseChanged());
}

export function* onGetBalanceSheetReportDetails() {
	yield takeLatest(BalanceSheetType.GET_BALANCE_SHEET_REPORT_START, balancesheetReportListGet);
}

export function* onGetBalanceSheetReportResponseReset() {
	yield takeLatest(
		BalanceSheetType.GET_BALANCE_SHEET_REPORT_RESPONSE_RESET,
		resetGetBalanceSheetReportResponse,
	);
}
/** *********************  END  GET BALANCE SHEET REPORT LIST ******************** */

export function* balanceSheetSaga() {
	yield all([
		call(onGetprofitLossReportListResponseReset),
		call(onGetProfitLossReportListDetails),
		call(onGetBalanceSheetReportResponseReset),
		call(onGetBalanceSheetReportDetails),
	]);
}
